import React, { useState, useEffect, useRef } from 'react';
import styles from './InvitationMessage.module.css';

const InvitationMessage: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

   useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.3,
        rootMargin: '0px'
      }
    );

    const currentRef = sectionRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section className={styles.invitationMessage} ref={sectionRef}>
      <div className="container">
        <p className={`${styles.messageText} ${isVisible ? styles.popIn : ''}`}>
          Te invito a celebrar el inicio de una nueva etapa en mi vida, llena de sueños, metas y grandes logros.
        </p>
        <div className={`${styles.heartDivider} ${isVisible ? styles.popIn : ''}`}>
          ♡
        </div>
      </div>
    </section>
  );
};

export default InvitationMessage;